import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddNewHotel, fetchCountryList, getHotelList, getSuggestList, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";
import ViewHotelDetails from "./ViewHotel.jsx";
import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import debounce from "lodash.debounce";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";
import { useDebounce } from "../../../Components/hooks/useDebounce.js";
import { clickOutSide, isEmpty } from "../../../utils/common.js";
import RichTextEditor from "../../../Components/RichTextEditor/RichText.js";
import { AlertWrapper } from "../../../assets/styles/AlerWrapper.js";


const initValue = {
    code: "",
    active: "",
    name:"",
    email: "",
    fax:"",
    phone:"",
    checkOutTime:"",
    checkInTime:"",
    starRating:"",
    countryCode:"",
    cityName:"",
    cityId:"",
    pinCode:"",
    description:"",
    geoPoint:"",
    address:"",
    feedSource:""
    
   
  }
 const AddHotel = () => {

  const outSideRef = useRef(null)
  const outSideRefCountry = useRef(null)

        const [showHotel,SetShowHotel] = useState(false);
        const [newHotelData, setNewHotelData] = useState({...initValue});
        const [errors, setErrors] = useState({});
        const navigate = useNavigate();
        const [suggestions, setSuggestions] = useState([]);
        const [showSuggestions, setShowSuggestions] = useState(false);

        const [countryList, setCountryList] = useState([]);
        const [filteredCountries, setFilteredCountries] = useState([]);
        const [isOpen, setIsOpen] = useState(false);
        const [showSource, setShowSource] = useState(false); 
        const [message, setMessage] = useState({ type: "", message: "" });
        const [countryCode,setCountryCode] = useState("");
      
      
   const debounceCountry = useDebounce(countryCode, 500);
          
            useEffect(() => {
              fetchCountryList()
                .then((response) => {
                  setCountryList(response?.data?.data?.countries || []);
                })
                .catch((error) => {
                  console.error("Failed to fetch country list:", error);
                });
            }, []);
          
            useEffect(() => {
              const filtered = countryList.filter((country) => (country?.name || "").toLowerCase().includes((debounceCountry || "").toLowerCase()));
              setFilteredCountries(filtered || [])
            }, [debounceCountry, countryList]);
      
            const handleCountrySelect = (country) => {
             setNewHotelData((prevData) => ({
               ...prevData,
               //country: country.name,
               countryCode: country.iso2,
             }));
             setCountryCode(country.iso2)
             setIsOpen(false)
             setFilteredCountries([]);
           };
   
   
   
   
   
   
   
        const validateForm = () => {
        const newErrors = {};
      
        const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        // Validate Hotel Code
        if (!newHotelData.code) {
          newErrors.code = "Hotel Code is required";
        }
      
        // Validate Hotel Name
        if (!newHotelData.name) {
          newErrors.name = "Hotel Name is required";
        }
      
      
      
        // Validate City Name
        if (!newHotelData.cityName) {
          newErrors.cityName = "City Name is required";
        }
      
        // Validate Check-In Time
        if (!newHotelData.checkInTime) {
            newErrors.checkInTime = "Check-In time is required";
          } else if (!timeRegex.test(newHotelData.checkInTime)) {
            newErrors.checkInTime = "Check-In time must be in HH:mm format (e.g., 14:30)";
          }
          
      
        // Validate Check-Out Time
        if (!newHotelData.checkOutTime) {
            newErrors.checkOutTime = "Check-Out time is required";
          } else if (!timeRegex.test(newHotelData.checkOutTime)) {
            newErrors.checkOutTime = "Check-Out time must be in HH:mm format (e.g., 08:00)";
          }
        
      
        // Validate Geo Point (latitude,longitude format)
        if (!/^[-+]?\d{1,2}\.\d+,\s*[-+]?\d{1,3}\.\d+$/.test(newHotelData.geoPoint)) {
            newErrors.geoPoint = "Geo Point must be in 'latitude,longitude' format (e.g., 37.7749,-122.4194)";
          }
          
      
        // Validate Country Code (must be numeric)
        if (!newHotelData.countryCode) {
          newErrors.countryCode = "Country is required";
        }
      
        // Validate Phone Number (must be numeric)
        if (!newHotelData.phone || isNaN(newHotelData.phone)) {
          newErrors.phone = "Phone Number must be a number";
        }
      
        // Validate Star Rating (must be numeric)
        if (!newHotelData.starRating || isNaN(newHotelData.starRating)) {
          newErrors.starRating = "Star Rating must be a number";
        }
      
        // Validate Address
        if (!newHotelData.address) {
          newErrors.address = "Address is required";
        }
      
        // Validate Pin Code (must be numeric)
        if (!newHotelData.pinCode || isNaN(newHotelData.pinCode)) {
          newErrors.pinCode = "Pin Code must be a number";
        }
      
        // Validate Email (valid email format)
        if (!newHotelData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newHotelData.email)) {
          newErrors.email = "Invalid email address";
        }
      
        // Validate Active Status
        if (!newHotelData.active  || newHotelData.active === null) {
          newErrors.active = "Status is required";
        }
        if (!newHotelData.fax) {
          newErrors.fax = "fax is required";
        }
        if (!newHotelData.feedSource) {
          newErrors.feedSource = "Feed Source is required";
        }
      
        // Set errors state
        setErrors(newErrors);
      console.log("newErrors",newErrors)
        // Return true if no errors, false otherwise
        return Object.keys(newErrors).length === 0;
      };

      const handleModalInputChange = (e) => {
        const { name, value } = e.target;



        if(name === "countryCode"){
          setCountryCode(value);
          setNewHotelData((prev) => ({
            ...prev,
            countryCode: "",
          }))
          return;
        }
    
        // Restrict the "phone" field to numeric values only
        if ((name === "phone") || (name == "pinCode")) {
            const numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            setNewHotelData((prev) => ({
                ...prev,
                [name]: numericValue,
            }));
            return;
        }
    
        setNewHotelData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

const handleAddHotel = (key = "")=>{
  if(key == "add"){
    SetShowHotel((prev) => prev ? false: true);
  }

  if(key == "cancle"){
    setNewHotelData({...initValue})
    SetShowHotel((prev) => prev ? false: true);
  }
 
 // setNewHotelData(..newHotelData)

}

 const fetchSuggestions = (query, identifier,type) => {
        getSuggestList(query, identifier,type)
          .then((resp) => {
            console.log("API Response:", resp?.data.data.suggestions); // Debug response
            if (resp?.data.data.suggestions) {
              setSuggestions([...resp?.data.data.suggestions]);
     
             
            } else {
              setSuggestions([]);
              setShowSuggestions(false); // Handle no suggestions case
              
            }
          })
          .catch((error) => console.error("Error fetching suggestions:", error));
      };

      const debounceValue = useDebounce(newHotelData?.cityName, 500);

        useEffect(() =>{
              fetchSuggestions(debounceValue, "loc","1");
               },[debounceValue])

const handleSubmit = () => {
  console.log("newHotelData",newHotelData)
  if (!validateForm()) {
    console.log("Validation failed. Fix the errors before submitting.");
    setMessage({ type: "error", message: "Validation failed. Please fix errors before submitting." });
    return; // Stop further execution if validation fails
  }

  // Convert active field to boolean
  newHotelData.active = newHotelData.active === "true";

  AddNewHotel(newHotelData)
    .then((resp) => {
      console.log("res", resp);
      if (resp.status === 200) {
        setMessage({ type: "success", message: "Hotel added successfully" });
      } else {
        setMessage({ type: "error", message: "Failed to add hotel. Please try again." });
      }
    })
    .catch((error) => {
      console.error("Error adding hotel:", error);
      setMessage({ type: "error", message: "Something went wrong. Please try again later." });
    });
};



useEffect(()=>{
  if(!outSideRef) return
  clickOutSide(outSideRef,()=>setShowSuggestions(false));
  return  clickOutSide(outSideRef,()=>setShowSuggestions(false),"remove")
},[outSideRef])
useEffect(()=>{
  if(!outSideRefCountry) return
  clickOutSide(outSideRefCountry,()=>setIsOpen(false));
  return  clickOutSide(outSideRefCountry,()=>setIsOpen(false),"remove")
},[outSideRefCountry])


const handleDescriptionChange = (value) => {
  setNewHotelData((prevData) => ({
    ...prevData,
    description: value, // Update description in viewHotelData
  }));
}
useEffect(() =>{
  if( isEmpty(message)) return;
 
  setTimeout(() =>{
   setMessage({})
  },5000)
 
   },[message])


 return(
    <>
      
      <div className="main_container">
      {!isEmpty(message) && (
                         <AlertWrapper className={`${message.type} globle`}>
                           <span className="close" onClick={() => setMessage({})}>
                             ×
                           </span>
                           {message.message}
                         </AlertWrapper>
                       )}
      <div className="subadmin_container justify-between flex column gap-20">
         <div style={{padding:"30px",flex:"1 1 100%"}}>
            <p className="fs-5 fw-bold">Add New Hotel:</p>
           
           <div className="flex gap-10 mt-20">

            <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Hotel Code:</label>
                
                </div >
                <Input
                  type="text"
               
                placeholder="Hotel Code"
                  name="code"
                 value={newHotelData.code}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.code && (
                  <p className="error fs-12 mt-10">{errors.code}</p>
                )}
              </div>

              <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Hotel Name:</label>
                
                </div >
                <Input
                  type="text"
               
                placeholder="Hotel Name"
                  name="name"
                 value={newHotelData.name}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.name && (
                  <p className="error fs-12 mt-10">{errors.name}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Check In:</label>
                
                </div>
                <Input
                  type="time"
                
                  placeholder="Check In"
                  name="checkInTime"
                value={newHotelData?.checkInTime}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.checkInTime && (
                  <p className="error fs-12 mt-10">{errors.checkInTime}</p>
                )}
              </div>
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Check Out:</label>
                
                </div>
                <Input
                  type="time"
             
                  placeholder="Check Out"
                  name="checkOutTime"
                value={newHotelData?.checkOutTime}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.checkOutTime && (
                  <p className="error fs-12 mt-10">{errors.checkOutTime}</p>
                )}
              </div>

              
          
          
          
          </div>
        
        
        
        
          <div className="flex gap-10 mt-20" ref={outSideRef}>
             
             
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">City Name:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="City name"
                  name="cityName"
                value={newHotelData?.cityName}
                 onChange={handleModalInputChange}
                onFocus={() =>setShowSuggestions(true)}
                 // click={checkStatus}
                />
                {errors.cityName && (
                  <p className="error fs-12 mt-10">{errors.cityName}</p>
                )}

{ showSuggestions && (
     <div style={{position:"absolute"}}>
       <AutoSuggestion
    fromCityList={suggestions}
     //className="hotelCityName"
 
    setCityName={(name) =>
      setNewHotelData((prev) => ({
        ...prev,
        cityName: name,
      }))
    }
    setCityId={(id) =>
      setNewHotelData((prev) => ({
        ...prev,
        cityId: id, // Set the selected city ID
      }))

    }
   
    setShowCity={setShowSuggestions}
    showCity={{ fromCityShow: true }}
    cityNameKey="cityName"
    inputElement={null}
  />

     </div>
                  )}
              </div>
              
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Geo Point:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Geo Point"
                  name="geoPoint"
                value={newHotelData?.geoPoint}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.geoPoint && (
                  <p className="error fs-12 mt-10">{errors.geoPoint}</p>
                )}
              </div>
              <div  style={{flex:"1 1 50%",position:"relative"}} ref ={outSideRefCountry}>
                  <div className="labelname mb-5">
                    <label className="fw-bold">Country Code:</label>
                  </div>
                  <Input
                    type="text"
                   
                    placeholder="Country Code"
                    name="countryCode"
                    value={countryCode || ""}
                    onChange={handleModalInputChange}
                    onFocus={()=>setIsOpen(true)}
                  />

           {errors.countryCode && (
                  <p className="error fs-12 mt-10">{errors.countryCode}</p>
                )}
                    {filteredCountries.length > 0 && isOpen && (
                <div className="dropdown mt-10" style={{maxWidth:"330px",width:"100%",background:"#fff",position:"absolute"}}>
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="dropdown-item fs-14"
                      style={{paddingBottom:"5px",borderBottom:"1px solid #8080803d",paddingTop:"5px",cursor:"pointer"}}
                      onClick={() => handleCountrySelect(country)}
                    >
                      {country.name} ({country.iso2})
                    </div>
                  ))}
                </div>
              )}
             
                </div>
            
          </div>
              
            
       
          
          <div className="flex gap-10 mt-20">
          <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Phone:</label>
                
                </div>
                <Input
                  type="text"
                  maxLength={10}
                  placeholder="Phone"
                  name="phone"
                value={newHotelData?.phone}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.phone && (
                  <p className="error fs-12 mt-10">{errors.phone}</p>
                )}
              </div>
        
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Email:</label>
                
                </div>
                <Input
                  type="text"
             
                  placeholder="Email"
                  name="email"
                value={newHotelData?.email}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.email && (
                  <p className="error fs-12 mt-10">{errors.email}</p>
                )}
              </div>

              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Fax:</label>
                
                </div>
                <Input
                  type="text"
                  
                  placeholder="Fax"
                  name="fax"
                value={newHotelData?.fax}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.fax && (
                  <p className="error fs-12 mt-10">{errors.fax}</p>
                )}
              </div>
        
        
        
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Star Rating</label>
                
                </div>
                <Input
                  type="text"
                 
                  placeholder="star Rating"
                  name="starRating"
                value={newHotelData?.starRating}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.starRating && (
                  <p className="error fs-12 mt-10">{errors.starRating}</p>
                )}
              </div>

              
              

             
          </div>
             <div className="flex gap-10 mt-20">

             <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Address:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Address"
                  name="address"
                value={newHotelData?.address}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.address && (
                  <p className="error fs-12 mt-10">{errors.address}</p>
                )}
              </div>
             
              <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Pin Code:</label>
                
                </div>
                <Input
                  type="text"
             
                  placeholder="Pin code"
                  name="pinCode"
                value={newHotelData?.pinCode}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.pinCode && (
                  <p className="error fs-12 mt-10">{errors.pinCode}</p>
                )}
              </div>
             
                <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                  <label className="fw-bold">Status:</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                   value={newHotelData.active}
                  onChange={handleModalInputChange}
                    >
                 
                   
                      <option value="">status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
                    {errors.active && (
                  <p className="error fs-12 mt-10">{errors.active}</p>
                )}
                  </div>
                  <div  style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Feed Source:</label>
                
                </div>
                <Input
                  type="text"
                
                  placeholder="Feed Source"
                  name="feedSource"
                value={newHotelData?.feedSource}
                 onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.feedSource && (
                  <p className="error fs-12 mt-10">{errors.feedSource}</p>
                )}
                  </div>
                 
               
                  
                  </div>
          

         <div className="flex gap-10 mt-20">
          
         <div style={{flex:"1 1 50%"}}>
            <RichTextEditor onContentChange={handleDescriptionChange} initialContent={newHotelData?.description}></RichTextEditor>
           </div>
              
              

             
          </div>
          <div className="flex gap-10 mt-20">
          
            
              
              

             
          </div>
         
        

         </div>
       
         <div className="flex gap-10" style={{padding:"30px"}}>
        
       
        <div>
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         </div>
         </div>

      </div>
         

       
    
    </>
 )



    }
export default AddHotel